import axios from "axios";
import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import swal from "sweetalert";
import imagePath from "../../../CSS/imagePath";

const LearningModal1 = (props) => {
  const {
    changeRoute,
    setChangeRoute,
    modalShow1,
    modalChange,
    setModalChange,
    setModalShow1,
    learningSession,
  } = props;
  const [inputData, setInputData] = useState({
    name: "",
    father_name: "",
    password: "",
    error_list: [],
  });

  const handleInput = (e) => {
    e.persist();
    setInputData({ ...inputData, [e.target.name]: e.target.value });
  };

  const submitCertificateData = (e) => {
    e.preventDefault();
    const data = {
      event_id: learningSession.id,
      name: inputData.name,
      father_name: inputData.father_name,
      password: inputData.password,
    };

    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios
        .post(`/api/user/learning-session/saveCertificateInfo`, data)
        .then((res) => {
          if (res.data.status === 200) {
            swal("Success", res.data.message, "success");
            setChangeRoute(1);
            setModalChange(1);
          } else if (res.data.status === 401) {
            swal("Warning", res.data.message, "warning");
          } else {
            setInputData({
              ...inputData,
              error_list: res.data.validation_errors,
            });
          }
        });
    });
  };

  const handleClick = (e) => {
    setModalShow1(false);
    submitCertificateData(e);
  };

  return (
    <>
      <Modal
        {...props}
        size="m"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <div className="container">
          <div className="row ModalRSA my-4 mx-1 mt-5">
            <div className="col-md-3 text-light my-3">Your Name</div>
            <div className="col-md-9 card txpw text-light  my-3">
              <input
                className="iPc"
                type="text"
                name="name"
                onChange={handleInput}
              />
              <span className="text-danger">{inputData.error_list.name}</span>
            </div>
            <div className="col-md-3 text-light my-3">Your Father Name</div>
            <div className="col-md-9 card txpw text-light  my-3">
              <input
                className="iPc"
                type="text"
                name="father_name"
                onChange={handleInput}
              />
              <span className="text-danger">
                {inputData.error_list.father_name}
              </span>
            </div>
            <div className="col-md-3 text-light my-3">Password</div>
            <div className="col-md-9 card txpw text-light  my-3">
              <input
                className="iPc"
                type="password"
                name="password"
                onChange={handleInput}
              />
              <span className="text-danger">
                {inputData.error_list.password}
              </span>
            </div>

            <center>
              <button
                // onClick={(props.onHide, () => setChangeRoute(1))}
                onClick={(e) => handleClick(e)}
                // onClick={(e)=>submitCertificateData(e)}
                className="btn btnvs mt-3 my-2 px-5 fw-bold"
              >
                Apply
              </button>
            </center>

            <img
              onClick={() => setModalShow1(false)}
              src={imagePath.delPS}
              alt=""
              className="imgsa me-2"
            />
          </div>
        </div>
      </Modal>
    </>
  );
};

export default LearningModal1;
